import React, { lazy, Suspense } from 'react';

const LazyPreviousOrderMerchandise = lazy(() => import('./PreviousOrderMerchandise'));

const PreviousOrderMerchandise = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyPreviousOrderMerchandise {...props} />
  </Suspense>
);

export default PreviousOrderMerchandise;
